import { render, staticRenderFns } from "./ProductDropdownContainer.vue?vue&type=template&id=4ea3de44&"
import script from "./ProductDropdownContainer.vue?vue&type=script&lang=ts&"
export * from "./ProductDropdownContainer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports